import { AppLocation } from 'src/navigation/appLocations'
import * as Routes from 'src/navigation/urls'

// Family route tree — single source for paths, metadata, and tab descriptors (src/navigation/AGENTS.md).

export interface CardsFamilyTabNode {
  /** Stable key used for active-tab detection. */
  key: string
  /** Translation key. (Unused for rendering — the family has no tab bar.) */
  labelSource: string
  /** AppLocation that drives sidenav active state via locationHooks. */
  appLocation: AppLocation
  /** Exact URL pattern, e.g. `/cards/physicalcards`. */
  path: string
}

export const cardsRouteTree = {
  family: {
    /** `/cards` — redirects to the Physical Cards surface (legacy parity). */
    rootPath: Routes.cardsUrl(),
    rootAppLocation: AppLocation.Cards,
    redirectTo: Routes.cardsPhysicalCardsUrl(),
    tabs: [
      {
        key: 'physicalcards',
        labelSource: 'Physical Cards',
        appLocation: AppLocation.PhysicalCards,
        path: Routes.cardsPhysicalCardsUrl(),
      },
    ] as CardsFamilyTabNode[],
  },
}

/**
 * Family root + every static family path; enumerated since there's no entity
 * route to disambiguate against.
 */
export const cardsFamilyGatePaths: string[] = [
  cardsRouteTree.family.rootPath,
  ...cardsRouteTree.family.tabs.map((t) => t.path),
]
